import "./App.css";
import { AppRoutes } from "@web/AppRoutes";
import type { I18nProvider } from "react-admin";

function App({ i18nProvider }: { i18nProvider: I18nProvider }) {
  return (
    <div>
      <AppRoutes i18nProvider={i18nProvider} />
    </div>
  );
}

export default App;
